'use strict';

angular.module('amexReconciliationApp')
  .component('travelDataPanel', {
    templateUrl: 'scripts/views/components/travel-data-panel.html',
    controller: function ($scope, 
                          ActiveTransactionModel, 
                          TpdRepository, 
                          UserModel,
                          TransactionSearchModel) {
      var self = this;

      self.loading = true;
      self.isLimitedRole = TransactionSearchModel.isLimitedRole;
      self.getCurrencyFormat = UserModel.getCurrencyFormat;

      ActiveTransactionModel.onActiveTransactionChanged($scope, function (newActiveTransaction) {
        var thirdPartyDataId = _.get(newActiveTransaction, 'transactionThirdPartyData[0].thirdPartyDataId', null);
        self.thirdPartyData = null;
        if (thirdPartyDataId) {
          TpdRepository.find(thirdPartyDataId).then(function (thirdPartyData) {
            self.thirdPartyData = thirdPartyData;
            self.loading = false;
          }).finally(function () {
            self.loading = false;
          });
        }else{
          self.loading = false;
        }
      });

      self.hasTravelData = function() {
        return !!self.thirdPartyData;
      };
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/travelDataPanel.js
// module id = 501
// module chunks = 0